export class Location {

    constructor(
        public fullAddress?: string,
        public city?: string,
        public country?: string,
        public latitude? : number,
        public longitude? : number,
    ) {}
}